// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_3fL7R","premiumFolderIcon":"_3fL7R","widget-paywall-locked":"_34l3L","widgetPaywallLocked":"_34l3L"};